import { render, staticRenderFns } from "./subject-view.vue?vue&type=template&id=dd9761ba&"
import script from "./subject-view.vue?vue&type=script&lang=js&"
export * from "./subject-view.vue?vue&type=script&lang=js&"
import style0 from "./subject-view.vue?vue&type=style&index=0&id=dd9761ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports